import {
  AfterViewInit,
  ChangeDetectorRef,
  Compiler,
  ComponentRef,
  Directive,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewContainerRef
} from '@angular/core';
import {HttpClient} from '@angular/common/http';

declare var $: any;

@Directive({selector: '[app-html-interpolation]'})
export class HtmlInterpolationDirective implements AfterViewInit, OnInit, OnDestroy {

  @Input() ignoreElements?: string[] = [];

  private _inputHtml = '';
  private _data: any = {};

  // https://angular.io/guide/lifecycle-hooks (no init needed here)
  @Input() set inputHtml(value: string) {
    if (!value) {
      value = '';
    }
    this._inputHtml = value;
  }

  // https://angular.io/guide/lifecycle-hooks (no init needed here)
  @Input() set data(value: any) {
    if (!value) {
      value = {};
    }
    this._data = value;
  }

  componentRefList: ComponentRef<any>[] = [];

  constructor(private cd: ChangeDetectorRef,
              private compiler: Compiler,
              private elementRef: ElementRef,
              private http: HttpClient,
              private _ngZone: NgZone,
              private _viewContainerRef: ViewContainerRef) {
  }

  ngAfterViewInit(): void {
    this.init();
  }

  init() {
    this._viewContainerRef.clear();

    // var node = $("<div>" + this.inputHtml + "</div>")[0]
    this.elementRef.nativeElement.innerHTML = this._inputHtml;

    const node = this.elementRef.nativeElement;

    for (const e of this.ignoreElements) {
      $(node).find(e).remove();
    }
  }

  ngOnDestroy(): void {
    if (this.componentRefList) {
      this.componentRefList.forEach(a => {
        a.destroy();
      });
    }
  }

  ngOnInit(): void {
  }

}

